import { Box, BoxProps, ColorOptions, convertHexToRGBA, Spacer, Text } from '@jfs/ui-new'
import { weDoItAllData } from '../../static/staticData'
import { colors } from '../../util/colors'
import { LinearGradientContainer } from '../LinearGradient'

interface props {
  radius: number
  color?: ColorOptions
  isGradiant?: boolean
  gradiantAngle?: number
  gradiantColors?: any
}
const CircleBg = ({ radius, color, isGradiant = false, gradiantAngle = 0, gradiantColors }: props) => {
  if (isGradiant) {
    return (
      <LinearGradientContainer
        colorArray={gradiantColors}
        direction="HORIZONTAL"
        useAngle={true}
        angle={gradiantAngle}
        customStyle={{
          width: 2 * radius,
          height: 2 * radius,
          borderRadius: radius,
          position: 'absolute',
        }}>
        <Spacer />
      </LinearGradientContainer>
    )
  }
  return <Box w={2 * radius} h={2 * radius} borderRadius={radius} bg={color} position={'absolute'} />
}

export const shadowStyle = {
  shadowOffset: { width: 2, height: 1 },
  shadowRadius: 16,
  shadowColor: '#00000029',
  zIndex: 10,
}

const outerCircle = (isMob: boolean) => {
  return {
    width: isMob ? 24 : 90,
    height: isMob ? 24 : 90,
    borderRadius: isMob ? 12 : 45,
    justify: 'center',
    align: 'center',
    bg: 'WHITE',
    ...shadowStyle,
  } as BoxProps
}

const degToRad = (deg: number) => {
  return (deg * Math.PI) / 180
}

const OuterCircle = ({ item, isMobile }: any) => {
  const { angle, top = 180, left = 180, label, component: SVGComponent } = item
  const firstCircleRadius = isMobile ? 100 : 240
  const angleRad = degToRad(angle)

  const x = firstCircleRadius * Math.cos(angleRad) + left
  const y = firstCircleRadius * Math.sin(angleRad) + top

  const flexDir = () => {
    if ((angle >= 0 && angle < 90) || (angle > 270 && angle <= 360)) {
      return 'row'
    } else if (angle === 90) {
      return 'column'
    } else if (angle > 90 && angle < 270) {
      return 'row-reverse'
    } else {
      return 'column-reverse'
    }
  }
  return (
    <Box position={'absolute'} justify={'center'} align={'center'} left={x} top={y} flexDirection={flexDir()}>
      <Box {...outerCircle(isMobile)}>
        <Box width={isMobile ? 14 : 48} height={isMobile ? 14 : 48} borderWidth={0} justify={'center'} align={'center'}>
          <SVGComponent width={isMobile ? 14 : 48} height={isMobile ? 14 : 48} />
        </Box>
      </Box>
      <Spacer direction="horizontal" size={isMobile ? 8 : 16} />
      <Spacer direction="vertical" size={16} />
      <Text
        title={label}
        fontFamily={isMobile ? 'jiotype-light' : 'jiotype-medium'}
        color={'BLACK_21' as ColorOptions}
        fontSize={isMobile ? 8 : 18}
        numberOfLines={1}
      />
    </Box>
  )
}

interface Props {
  isTab: boolean
  isMobile: boolean
}

export const WeDoItSection = ({ isMobile }: Props) => {
  return (
    <Box
      justify={'center'}
      alignSelf={'center'}
      align={'center'}
      mt={isMobile ? 120 : 200}
      h={isMobile ? 190 : 480}
      w={isMobile ? 240 : 480}>
      <CircleBg
        radius={isMobile ? 78 : 240}
        isGradiant={true}
        gradiantAngle={135}
        gradiantColors={[convertHexToRGBA('#D1E2FF', 20), convertHexToRGBA('#F1E5FF', 20)]}
      />
      <CircleBg
        radius={isMobile ? 70 : 215}
        isGradiant={true}
        gradiantAngle={135}
        gradiantColors={[convertHexToRGBA('#D1E2FF', 30), convertHexToRGBA('#F1E5FF', 30)]}
      />
      <CircleBg
        radius={isMobile ? 64 : 195}
        isGradiant={true}
        gradiantAngle={135}
        gradiantColors={['#D1E2FF', '#F1E5FF']}
      />
      <CircleBg
        radius={isMobile ? 50 : 150}
        isGradiant={true}
        gradiantAngle={135}
        gradiantColors={['#C5D9FA', '#F1E7FD']}
      />
      <Box position={'absolute'}>
        <Text
          title="We do it all!"
          fontFamily="jiotype-black"
          color={colors.JIO_PRIMARY_ALPHA as ColorOptions}
          fontSize={isMobile ? 12 : 36}
        />
      </Box>
      {weDoItAllData(isMobile).map((item: any) => {
        return <OuterCircle item={item} isMobile={isMobile} />
      })}
    </Box>
  )
}
